var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 121,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.5 24.25a7 7 0 1 1 0 14h-40a7 7 0 1 1 0 14h22a7 7 0 1 1 0 14h-10.174c-4.874 0-8.826 3.134-8.826 7 0 2.577 2 4.91 6 7a7 7 0 1 1 0 14h-83a7 7 0 1 1 0-14h-39a7 7 0 1 1 0-14h40a7 7 0 1 0 0-14h-25a7 7 0 1 1 0-14h40a7 7 0 1 1 0-14h98Zm0 28a7 7 0 1 1 0 14 7 7 0 0 1 0-14Z",
    fill: "#85B440",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m131.169 23.25 9.302 67.843.836 6.806a4 4 0 0 1-3.483 4.458l-58.56 7.19a4 4 0 0 1-4.458-3.483l-9.015-73.427a2 2 0 0 1 1.741-2.229l.02-.002 4.86-.545 58.757-6.61Zm-54.83 6.17 4.588-.515-4.587.515Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m76.34 29.42 4.587-.515m50.242-5.655 9.302 67.843.836 6.806a4 4 0 0 1-3.483 4.458l-58.56 7.19a4 4 0 0 1-4.458-3.483l-9.015-73.427a2 2 0 0 1 1.741-2.229l.02-.002 4.86-.545 58.757-6.61Z",
    stroke: "#85B440",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m128.637 27.52 8.419 61.483.758 6.168c.244 1.987-1.15 3.793-3.114 4.035l-52.442 6.439c-1.963.241-3.753-1.175-3.997-3.162l-8.15-66.376a2 2 0 0 1 1.741-2.23l6.488-.796",
    fill: "#85B440",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.729 10.5H88.172c-.76 0-1.447.308-1.945.806a2.741 2.741 0 0 0-.805 1.944v76c0 .76.308 1.447.805 1.945a2.741 2.741 0 0 0 1.945.805h59a2.74 2.74 0 0 0 1.944-.805 2.74 2.74 0 0 0 .806-1.945V26.685c0-.73-.29-1.43-.806-1.945l-13.443-13.435a2.75 2.75 0 0 0-1.944-.805Z",
    fill: "#fff",
    stroke: "#85B440",
    strokeWidth: 2.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M134.172 11.653V23.25a3 3 0 0 0 3 3h7.933M96.172 77.25h26m-26-51h26-26Zm0 12h43-43Zm0 13h43-43Zm0 13h43-43Z",
    stroke: "#85B440",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.53b75815393a1a9e623c3a416723de95.svg";
export { ForwardRef as ReactComponent };